<div class="filter-options">
	<div class="qc-filter-title">
		<div class="fishbone-toggle">
			<label>Fishbone</label>
			<mat-slide-toggle
				[(ngModel)]="isFishboneOn"
				(change)="onToggleFishbone()">
			</mat-slide-toggle>
		</div>
		<div class="qc-refresh">
			<label>Re-build</label>
			<i class="glyphicons glyphicons-refresh" (click)="buildFishbone()"></i>
		</div>
	</div>
	<div>
		TODO: Legend
	</div>
	<div *ngIf="false" class="filter-level-1">
		<div class="filter-check-all">
			<i *ngIf="filterOptions?.length" class="glyphicons" [ngClass]="{'glyphicons-filter-remove': isCheckAll, 'glyphicons-filter-applied': !isCheckAll}" [title]="isCheckAll ? 'Uncheck All':'Check All'"  (click)="toggleCheckAll()"></i>
		</div>
		<div>
			<div *ngFor="let option of filterOptions; let idx = index" class="filter-option-item" [title]="option.descriptionLong">
				<mat-checkbox
					name="option-{{idx}}"
					[(ngModel)]="option.isSelected"
					(ngModelChange)="toggleFilterOption()">
				</mat-checkbox>
				<div class="option-legend" [ngSwitch]="option.value">
					<div *ngSwitchCase="'FS1'" class="legend-circle legend-circle-small">
						<div class="legend-black"></div>
					</div>
					<div *ngSwitchCase="'FS2'" class="legend-circle legend-circle-small">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FS3'" class="legend-circle legend-circle-large">
						<div class="legend-black"></div>
					</div>
					<div *ngSwitchCase="'FS4'" class="legend-circle legend-circle-large">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FS5'" class="legend-diamond legend-diamond-large">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FS6'" class="legend-diamond legend-diamond-large">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FS7'" class="legend-diamond legend-diamond-small">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FS8'" class="legend-diamond legend-diamond-small">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FS9'" class="legend-triangle legend-triangle-large">
						<div></div>
					</div>
					<div *ngSwitchCase="'FSA'" class="legend-line-thin">
						<div class="legend-red"></div>
					</div>
					<div *ngSwitchCase="'FSB'" class="legend-line-thin">
						<div class="legend-red"></div>
					</div>
				</div>
				<label class="option-label" title="{{option.value + ': ' + option.descriptionLong}}">{{option.name}}</label>
			</div>
		</div>
	</div>
	<div *ngIf="false" class="bottom-filters">
		<div class="filter-option-item" title="Cross bone">
			<div class="option-legend">
				<div class="legend-line-thin">
					<div class="legend-red"></div>
				</div>
			</div>
			<label class="option-label" title="Cross bone">Cross Bone</label>
		</div>
		<div class="filter-option-item" title="Long bone">
			<div class="option-legend">
				<div class="legend-line-thin">
					<div class="legend-red"></div>
				</div>
			</div>
			<label class="option-label" title="Long bone">Long Bone</label>
		</div>
	</div>
</div>